import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute  } from '@angular/router';
import { Platform } from '@ionic/angular';


@Component({
  selector: 'app-feedback',
  templateUrl: './feedback.page.html',
  styleUrls: ['./feedback.page.scss'],
})
export class FeedbackPage  implements OnInit {

  feedbakTitle = '';     // viene por parametro
  feedbackText = '';     // viene por parametro
  feedbackBtnText = '';  // viene por parametro
  feedbackPath = '';     // viene por parametro

  constructor(private router: Router,
              private activateRoute: ActivatedRoute,
              public platform: Platform) {

  }

  ngOnInit() {
    this.feedbakTitle = this.activateRoute.snapshot.paramMap.get('title');
    this.feedbackText = this.activateRoute.snapshot.paramMap.get('text');
    this.feedbackBtnText = this.activateRoute.snapshot.paramMap.get('btnText');
    this.feedbackPath = this.activateRoute.snapshot.paramMap.get('path');
  }

  backHome() {
    this.router.navigate(['/home']);
  }

  secondButton() {
    this.router.navigate(['/' + this.feedbackPath]);
  }

  shareViaWhatsApp() {
   // this.shareService.createPdf();
  }

}
